/* SNEAP cart: drawer open/close, quantity, upsell, gifts, discount codes, note, protection, countdown */
(function () {
  var S = (window.SNEAP = window.SNEAP || {});
  if (S.__cart) return;
  S.__cart = true;

  var TIMER_KEY = 'sn_cart_timer_end';
  var PROTECT_OFF_KEY = 'sn_protect_off';
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }

  function roots() { return [].slice.call(document.querySelectorAll('[data-sn-cart-root]')); }
  function sectionIds() { return roots().map(function (r) { return r.dataset.section; }).filter(Boolean); }
  function drawer() { return document.getElementById('sn-cart-drawer'); }
  function overlay() { return document.querySelector('[data-sn-cart-overlay]'); }
  function isCartPage() { return !!document.querySelector('.sn-cart--page'); }

  /* Replace each cart root with fresh HTML from the Section Rendering API */
  function apply(sections) {
    if (!sections) return;
    roots().forEach(function (r) {
      var html = sections[r.dataset.section];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-sn-cart-root]');
      if (fresh) r.innerHTML = fresh.innerHTML;
    });
    afterRender();
  }

  function post(url, body) {
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;
    return fetch(S.url(url), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) { var e = new Error(d.description || d.message || (S.t||{}).error || 'Error'); e.data = d; throw e; } return d; }); });
  }

  function refresh() {
    var ids = sectionIds();
    var cartP = S.fetchCart().then(function (c) { S.updateCount(c); return c; });
    if (!ids.length) return cartP;
    var secP = fetch(S.url('?sections=' + encodeURIComponent(ids.join(','))), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(apply).catch(function () {});
    return Promise.all([cartP, secP]).then(function (res) { return res[0]; });
  }

  /* ---------- Drawer ---------- */
  function open(opener) {
    var d = drawer();
    if (!d) { window.location.href = S.cartUrl || S.url('cart'); return; }
    if (d.classList.contains('is-open')) return;
    d.removeAttribute('inert'); d.setAttribute('aria-hidden', 'false');
    d.classList.add('is-open');
    var o = overlay(); if (o) o.classList.add('is-open');
    S.lock(d, opener && opener.nodeType ? opener : document.activeElement);
    setTimeout(function () { var c = d.querySelector('[data-sn-close]'); if (c) c.focus({ preventScroll: true }); }, 80);
    startTimer();
  }
  function close() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); d.setAttribute('inert', '');
    var o = overlay(); if (o) o.classList.remove('is-open');
    S.unlock(d);
  }
  S.cart = { open: open, close: close, refresh: refresh };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sn-cart-overlay]')) { close(); return; }
    var c = e.target.closest('#sn-cart-drawer [data-sn-close]');
    if (c) { close(); return; }
    /* Header cart icon on the cart page itself: just reload the page */
    var opener = e.target.closest('[data-sn-cart-open]');
    if (opener && isCartPage()) { e.stopImmediatePropagation(); }
  }, true);

  /* ---------- Quantity / remove ---------- */
  function changeLine(li, qty) {
    if (!li) return;
    li.classList.add('is-busy');
    post('cart/change.js', { line: Number(li.dataset.line), quantity: Math.max(0, qty) })
      .then(function (d) { S.updateCount(d); apply(d.sections); document.dispatchEvent(new CustomEvent('sneap:cart-updated', { detail: { cart: d } })); })
      .catch(function (err) { li.classList.remove('is-busy'); S.toast(err.message); refresh(); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sn-cart-root] [data-sn-qty]');
    if (!b) return;
    e.preventDefault();
    changeLine(b.closest('.sn-ci'), Number(b.dataset.snQty));
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-sn-cart-root] [data-sn-qty-input]');
    if (inp) changeLine(inp.closest('.sn-ci'), parseInt(inp.value, 10) || 0);
  });
  document.addEventListener('keydown', function (e) {
    var inp = e.target.closest && e.target.closest('[data-sn-cart-root] [data-sn-qty-input]');
    if (inp && e.key === 'Enter') { e.preventDefault(); inp.blur(); }
  });

  /* ---------- Upsell / gift add (stays in the cart) ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sn-cart-root] [data-sn-up-variant]');
    if (!sel) return;
    var card = sel.closest('.sn-cu__card');
    var btn = card.querySelector('[data-sn-cart-add]');
    var opt = sel.options[sel.selectedIndex];
    btn.dataset.snCartAdd = sel.value;
    var price = card.querySelector('[data-sn-up-price]');
    if (price && opt) price.textContent = opt.dataset.price;
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sn-cart-root] [data-sn-cart-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true; b.classList.add('is-busy');
    var item = { id: Number(b.dataset.snCartAdd), quantity: 1 };
    if (b.dataset.props === 'gift') item.properties = { _sn_gift: 'yes' };
    post('cart/add.js', { items: [item] })
      .then(function (d) { apply(d.sections); return S.fetchCart().then(S.updateCount); })
      .catch(function (err) { b.disabled = false; b.classList.remove('is-busy'); S.toast(err.message); });
  });

  /* ---------- Upsell arrows ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-sn-cart-root] [data-sn-cu-prev], [data-sn-cart-root] [data-sn-cu-next]');
    if (!a) return;
    var track = a.closest('.sn-cu').querySelector('[data-sn-cu-track]');
    var card = track.querySelector('.sn-cu__card');
    var step = card ? card.getBoundingClientRect().width + 10 : 240;
    track.scrollBy({ left: a.hasAttribute('data-sn-cu-next') ? step : -step, behavior: S.reduceMotion() ? 'auto' : 'smooth' });
  });
  function syncArrows() {
    document.querySelectorAll('[data-sn-cart-root] .sn-cu').forEach(function (u) {
      var t = u.querySelector('[data-sn-cu-track]');
      var p = u.querySelector('[data-sn-cu-prev]'), n = u.querySelector('[data-sn-cu-next]');
      function upd() {
        var max = t.scrollWidth - t.clientWidth - 2;
        if (p) p.disabled = t.scrollLeft <= 2;
        if (n) n.disabled = t.scrollLeft >= max;
        u.querySelector('.sn-cu__nav').hidden = max <= 0;
      }
      if (!t.dataset.bound) { t.dataset.bound = '1'; t.addEventListener('scroll', upd, { passive: true }); }
      upd();
    });
  }

  /* ---------- Discount codes ---------- */
  function currentCodes(form) {
    return (form.dataset.codes || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-sn-cart-root] [data-sn-discount]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="discount"]');
    var code = (input.value || '').trim();
    var err = form.parentNode.querySelector('[data-sn-discount-error]');
    if (!code) { input.focus(); return; }
    var codes = currentCodes(form);
    if (codes.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) === -1) codes.push(code);
    var btn = form.querySelector('button'); btn.disabled = true;
    var rootSid = form.closest('[data-sn-cart-root]').dataset.section;
    post('cart/update.js', { discount: codes.join(',') })
      .then(function (d) {
        var found = (d.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
        apply(d.sections);
        S.updateCount(d);
        if (!found || !found.applicable) {
          var root = document.querySelector('[data-sn-cart-root][data-section="' + rootSid + '"]');
          var e2 = root && root.querySelector('[data-sn-discount-error]');
          var f2 = root && root.querySelector('[data-sn-discount]');
          if (e2) { e2.textContent = (f2 && f2.dataset.error) || (S.t||{}).code_invalid || 'This code isn’t valid for your cart.'; e2.hidden = false; }
          if (f2) { var d2 = f2.closest('details'); if (d2) d2.open = true; var i2 = f2.querySelector('input'); if (i2) { i2.value = code; i2.focus(); } }
          /* drop the code that didn't apply so it doesn't linger */
          if (found && !found.applicable) {
            var keep = (d.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
            post('cart/update.js', { discount: keep.join(',') }).then(function () {}).catch(function () {});
          }
        }
        document.dispatchEvent(new CustomEvent('sneap:cart-updated', { detail: { cart: d } }));
      })
      .catch(function (er) { btn.disabled = false; if (err) { err.textContent = er.message; err.hidden = false; } });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sn-cart-root] [data-sn-remove-code]');
    if (!b) return;
    var form = b.closest('.sn-disc').querySelector('[data-sn-discount]');
    var rm = b.dataset.snRemoveCode.toLowerCase();
    var codes = currentCodes(form).filter(function (c) { return c.toLowerCase() !== rm; });
    b.disabled = true;
    post('cart/update.js', { discount: codes.join(',') })
      .then(function (d) { S.updateCount(d); apply(d.sections); })
      .catch(function (er) { b.disabled = false; S.toast(er.message); });
  });

  /* ---------- Order note (saved as you type) ---------- */
  var noteTimer;
  document.addEventListener('input', function (e) {
    var t = e.target.closest('[data-sn-cart-root] [data-sn-note]');
    if (!t) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(S.url('cart/update.js'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: t.value }) });
    }, 500);
  });

  /* ---------- Shipping protection ---------- */
  document.addEventListener('change', function (e) {
    var sw = e.target.closest('[data-sn-cart-root] [data-sn-protect]');
    if (!sw) return;
    var cart = sw.closest('.sn-cart');
    var vid = Number(cart.dataset.protection);
    sw.disabled = true;
    var p;
    if (sw.checked) { ls(PROTECT_OFF_KEY, null); p = post('cart/add.js', { items: [{ id: vid, quantity: 1 }] }); }
    else { ls(PROTECT_OFF_KEY, '1'); p = post('cart/change.js', { id: sw.dataset.key, quantity: 0 }); }
    p.then(function (d) { apply(d.sections); return S.fetchCart().then(S.updateCount); })
      .catch(function (er) { sw.disabled = false; sw.checked = !sw.checked; S.toast(er.message); });
  });
  var protectBusy = false;
  function autoProtect() {
    var cart = document.querySelector('[data-sn-cart-root] .sn-cart');
    if (!cart || protectBusy) return;
    var vid = Number(cart.dataset.protection || 0);
    var items = Number(cart.dataset.items || 0);
    /* empty cart: remove a left-over protection line */
    var orphan = cart.querySelector('[data-sn-orphan]');
    if (orphan) { protectBusy = true; post('cart/change.js', { id: orphan.dataset.snOrphan, quantity: 0 }).then(function (d) { protectBusy = false; apply(d.sections); S.updateCount(d); }).catch(function () { protectBusy = false; }); return; }
    if (!vid || !items || cart.dataset.protectDefault !== 'true' || ls(PROTECT_OFF_KEY)) return;
    var sw = cart.querySelector('[data-sn-protect]');
    if (sw && !sw.checked) { protectBusy = true; post('cart/add.js', { items: [{ id: vid, quantity: 1 }] }).then(function (d) { protectBusy = false; apply(d.sections); }).catch(function () { protectBusy = false; }); }
  }

  /* ---------- Countdown ---------- */
  var tick;
  function startTimer() {
    clearInterval(tick);
    var cart = document.querySelector('[data-sn-cart-root] .sn-cart');
    if (!cart) return;
    var mins = Number(cart.dataset.timer || 0);
    var items = Number(cart.dataset.items || 0);
    if (!items) { ls(TIMER_KEY, null); return; }
    if (!mins) return;
    var end = Number(ls(TIMER_KEY)) || 0;
    if (!end) { end = Date.now() + mins * 60000; ls(TIMER_KEY, String(end)); }
    function draw() {
      var left = end - Date.now();
      document.querySelectorAll('[data-sn-cart-root] [data-sn-cart-timer]').forEach(function (row) {
        if (left <= 0) { row.hidden = true; return; }
        var m = Math.floor(left / 60000), s = Math.floor(left / 1000) % 60;
        row.querySelector('[data-sn-cart-time]').textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        row.hidden = false;
      });
      if (left <= 0) clearInterval(tick);
    }
    draw();
    tick = setInterval(draw, 1000);
  }

  function afterRender() {
    startTimer();
    syncArrows();
    autoProtect();
  }

  function init() {
    afterRender();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Back/forward cache: cart may have changed on another page */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('[data-sn-cart-root]')) init(); });
})();
